// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__3U2GT","error":"Alert_error__2Qbaa","icon":"Alert_icon__1mdLT","info":"Alert_info__IY38w","warning":"Alert_warning__2zKCr"};